import React from "react";


import MobileInputMask from "../../Common/MobileInputMask";
import _ from "lodash";
import {
  Input,
  Button,
  Select,
  Collapse,
  AutoComplete,
  InputNumber,
  TimePicker,
  DatePicker,
  Switch,
  Form,
  Row,
  Col,
  Modal,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { mypPMSlist } from "../../../utils/mappingData";

import moment from "moment-timezone";
moment.tz.setDefault("Etc/UTC");

const { Panel } = Collapse;
const { Option } = Select;

const projectData = [
  {
    hmg_label: "Second HMG",
    hmg_name: "hmg_main_two_id",
    hmg_placeholder: "Enter Secondary HMG",
    project_label: "Second Project",
    project_name: "secondary_hmg_id",
    project_placeholder: "Enter Secondary Project",
    field_name: "two",
  },
  {
    hmg_label: "Third HMG",
    hmg_name: "hmg_main_three_id",
    hmg_placeholder: "Enter Third HMG",
    project_label: "Third Project",
    project_name: "third_hmg_id",
    project_placeholder: "Enter Third Project",
    field_name: "three",
  },
  {
    hmg_label: "Fourth HMG",
    hmg_name: "hmg_main_four_id",
    hmg_placeholder: "Enter Fourth HMG",
    project_label: "Fourth Project",
    project_name: "fourth_hmg_id",
    project_placeholder: "Enter Fourth Project",
    field_name: "four",
  },
];

const customProps = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 14 },
    lg: { span: 14 },
    xl: { span: 14 },
    xxl: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
    lg: { span: 10 },
    xl: { span: 10 },
    xxl: { span: 12 },
  }
};



class FormOne extends React.Component {
  state = {
    mockData: [],
    targetKeys: [],
    initialValue: null,

  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.setState({ initialValue: this.props.initialValue });
      if (this.props.initialValue && this.props.initialValue.index_id) {
        this.setState({ targetKeys: this.props.initialValue.index_id });
      } else {
        this.setState({ targetKeys: [] });
      }
    }
  }

  handleChange = (targetKeys) => {
    this.setState({ targetKeys });
  };

  // checkFieldsError = async (fields) => {
  //   const { formRef } = this.props;
  //   const errors = await formRef?.current?.validateFields();
  //   console.log(errors, "errors");
  //   return false;
  // }

  pnaHotelOnChange = (checked) => {
    const { formRef } = this.props;
    if (!checked) {
      Modal.confirm({
        title: 'Is this a myP Only hotel?',
        width: 285,
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          formRef.current.setFieldsValue({ myp_hotel: true });
        },
        onCancel() {
          formRef.current.setFieldsValue({ pna_hotel: true });
        },
      });
    }
  }




  render() {
    const {
      formRef,
      onFinish,
      hotelGetData,
      hmgGetData,
      hmgMainGetData,
      pmsGetData,
      autoCompleteOneChange,
      autoCompleteOneSelect,
      createStatus,
      current,
      next,
      prev,
      steps,
      hotelCodeOneChange,
    } = this.props;
    const { initialValue } = this.state;

    const mypHotelToggle = () => {
      next();
      const mypHotelName = formRef?.current?.getFieldValue("myp_hotel_name");
      const mypHotelStatues = formRef?.current?.getFieldValue("hotel_status");
      if (createStatus) {
        (mypHotelName &&
          (mypHotelStatues === "Live" || mypHotelStatues === "Soft Live" || mypHotelStatues === "UAT"))
          ? formRef.current.setFieldsValue({ myp_hotel: true })
          : formRef.current.setFieldsValue({ myp_hotel: false });
      }
    }

    const hotelStatusOnChange = (value) => {
      // const primaryHmgId = formRef?.current?.getFieldValue("primary_hmg_id");
      // const result = hmgGetData.find((e) => e._id === primaryHmgId);
      // console.log(result);
      // if (result) {
      //   console.log(result.solution);
      //   if (result.solution && result.solution === "PNA") {
      //     formRef.current.setFieldsValue({ pna_hotel: true });
      //   }
      //   if (result.solution && result.solution === "MYP") {
      //     formRef.current.setFieldsValue({ myp_hotel: true });
      //   }
      // }
      if (value === "Live" || value === "Soft Live" || value === "UAT") {
        formRef.current.setFieldsValue({
          qc_db_create_and_update: "1",
          qc_enable_periodic_update: true,
          is_enabled: true,
        });
      } else if (value === "Sold" || value === "Lost") {
        formRef.current.setFieldsValue({
          qc_db_create_and_update: "1",
          qc_enable_periodic_update: false,
          is_enabled: false,
          pna_hotel: false,
          myp_hotel: false,
        });
      } else {
        formRef.current.setFieldsValue({
          qc_db_create_and_update:
            initialValue && initialValue.qc_db_create_and_update ? "1" : "0",
          qc_enable_periodic_update:
            initialValue && initialValue.qc_enable_periodic_update
              ? initialValue.qc_enable_periodic_update
              : false,
          is_enabled:
            initialValue && initialValue.is_enabled
              ? initialValue.is_enabled
              : false,
          pna_hotel:
            initialValue && initialValue.pna_hotel
              ? initialValue.pna_hotel
              : false,
          myp_hotel:
            initialValue && initialValue.myp_hotel
              ? initialValue.myp_hotel
              : false,
        });
      }
    };

    const dataSource = hotelGetData.map((d) => {
      return { value: d.hotel_name };
    });

    const hmgMainOptions = hmgMainGetData.map((d) => (
      <Option key={d._id}>{d.hmg_name}</Option>
    ));
    const mypoptionlist = mypPMSlist.map((d) => (
      <Option key={d.name}>{d.name}</Option>
    ));

    const pmsOptions = pmsGetData.map((d) => (
      <Option key={d._id}>{d.pms_name}</Option>
    ));



    return (
      <div>
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel
            header={_.startCase(_.camelCase(steps[current].title))}
            key="2_1"
          >
            <Form
              ref={formRef}
              labelCol={{
                xs: { span: 24 },
                sm: { span: 7 },
                md: { span: 7 },
                lg: { span: 7 },
                xl: { span: 7 },
                xxl: { span: 7 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 17 },
                md: { span: 17 },
                lg: { span: 17 },
                xl: { span: 17 },
                xxl: { span: 17 },
              }}
              // onSubmit={onSubmit}
              onFinish={onFinish}
              onKeyPress={(e) => e.key === "Enter" ? e.preventDefault() : ''}
            >
              <Form.Item name="_id" label="Id" style={{ display: "none" }}>
                <Input />
              </Form.Item>

              <div
                style={
                  current === 0 ? { display: "block" } : { display: "none" }
                }
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item
                      name="hotel_name_1"
                      label="Hotel Name"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Hotel Name",
                        },
                      ]}
                    >
                      <AutoComplete
                        options={dataSource}
                        placeholder="Enter Hotel Name"
                        filterOption={(inputValue, option) =>
                          option.value
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        }
                        onChange={autoCompleteOneChange}
                        onSelect={autoCompleteOneSelect}
                        allowClear={true}
                      />
                    </Form.Item>

                    <div
                      className="is_animation_1"
                      style={
                        createStatus ? { maxHeight: "0" } : { maxHeight: "100px" }
                      }
                    >
                      <Form.Item
                        name="hotel_name"
                        label="Rename Hotel Name"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Rename Hotel Name",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Rename Hotel Name" />
                      </Form.Item>
                    </div>

                    <Form.Item
                      name="hotel_code"
                      label="Hotel Code"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Hotel Code",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Hotel Code"
                        onChange={hotelCodeOneChange}
                      />
                    </Form.Item>


                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.hmg_main_one_id !== currentValues.hmg_main_one_id ||
                        prevValues.primary_hmg_id !== currentValues.primary_hmg_id ||
                        prevValues.hmg_list !== currentValues.hmg_list
                      }
                    >
                      {({ getFieldValue, setFieldValue }) => {
                        const hmgMainOneId = getFieldValue("hmg_main_one_id");
                        const hmgMainTwoId = getFieldValue(['hmg_list', 0, 'hmg_name']);
                        const hmgMainThreeId = getFieldValue(['hmg_list', 1, 'hmg_name']);
                        const hmgMainFourId = getFieldValue(['hmg_list', 2, 'hmg_name']);

                        const primaryHmgId = getFieldValue("primary_hmg_id");
                        const secondaryHmgId = getFieldValue(['hmg_list', 0, 'project_name']);
                        const thirdHmgId = getFieldValue(['hmg_list', 1, 'project_name']);
                        const fourthHmgId = getFieldValue(['hmg_list', 2, 'project_name']);


                        const projectOptions = {};
                        projectOptions.one = [];
                        projectOptions.two = [];
                        projectOptions.three = [];
                        projectOptions.four = [];

                        if (hmgGetData) {
                          hmgGetData.forEach((e) => {
                            const item = <Option key={e._id}>{e.project_name}</Option>;

                            if (hmgMainOneId) {
                              if (
                                e.hmg_id === hmgMainOneId &&
                                e._id !== secondaryHmgId &&
                                e._id !== thirdHmgId &&
                                e._id !== fourthHmgId
                              ) {
                                projectOptions.one.push(item);
                              }
                            }
                            if (hmgMainTwoId) {
                              if (
                                e.hmg_id === hmgMainTwoId &&
                                e._id !== primaryHmgId &&
                                e._id !== thirdHmgId &&
                                e._id !== fourthHmgId
                              ) {
                                projectOptions.two.push(item);
                              }
                            }
                            if (hmgMainThreeId) {
                              if (
                                e.hmg_id === hmgMainThreeId &&
                                e._id !== primaryHmgId &&
                                e._id !== secondaryHmgId &&
                                e._id !== fourthHmgId
                              ) {
                                projectOptions.three.push(item);
                              }
                            }
                            if (hmgMainFourId) {
                              if (
                                e.hmg_id === hmgMainFourId &&
                                e._id !== primaryHmgId &&
                                e._id !== secondaryHmgId &&
                                e._id !== thirdHmgId
                              ) {
                                projectOptions.four.push(item);
                              }
                            }
                          });
                        }
                        return (
                          <>
                            <Form.Item
                              name="hmg_main_one_id"
                              label="Primary HMG"
                              style={{ marginBottom: "5px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter Primary HMG",
                                },
                              ]}>
                              <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="Enter Primary HMG"
                                onChange={() => setFieldValue('primary_hmg_id', null)}
                                allowClear={true}
                              >
                                {hmgMainOptions}
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="primary_hmg_id"
                              label="Primary Project"
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter Primary Project",
                                },
                              ]}
                            >

                              <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="Enter Primary Project"
                              >
                                {projectOptions.one}
                              </Select>

                            </Form.Item>

                            {/* two ------------ */}

                            <Form.List name="hmg_list">
                              {(fields, { add, remove }) => (
                                <>
                                  {fields.map((field, i) => (
                                    <div key={i}>
                                      <Form.Item
                                        label={projectData[i].hmg_label}
                                        style={{ marginBottom: "5px" }}
                                      >
                                        <Form.Item
                                          name={[i, 'hmg_name']}
                                          rules={[
                                            {
                                              required: true,
                                              message: "Please " + projectData[i].hmg_placeholder,
                                            },
                                          ]}
                                          noStyle
                                        >
                                          <Select
                                            style={{ width: "calc(100% - 30px)" }}
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder={projectData[i].hmg_placeholder}
                                            allowClear={true}
                                            onChange={() => setFieldValue(['hmg_list', i, 'project_name'], null)}

                                          >
                                            {hmgMainOptions}
                                          </Select>
                                        </Form.Item>
                                        <MinusCircleOutlined
                                          className="dynamic-delete-button"
                                          onClick={() => remove(field.name)}
                                          style={{ margin: "0 8px" }}
                                        />
                                      </Form.Item>

                                      <Form.Item
                                        name={[i, 'project_name']}
                                        label={projectData[i].project_label}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Please " + projectData[i].project_placeholder,
                                          },
                                        ]}
                                      >
                                        <Select
                                          style={{ width: "calc(100% - 30px)" }}
                                          showSearch
                                          optionFilterProp="children"
                                          placeholder={projectData[i].project_placeholder}
                                        // onChange={(e) => projectOnChange(e, projectData[i].hmg_name)}
                                        >
                                          {projectOptions[projectData[i].field_name]}
                                        </Select>

                                      </Form.Item>
                                    </div>
                                  ))}

                                  <Form.Item
                                    wrapperCol={{
                                      xs: { span: 24, offset: 0 },
                                      sm: { span: 17, offset: 7 },
                                      md: { span: 17, offset: 7 },
                                      lg: { span: 17, offset: 7 },
                                      xl: { span: 17, offset: 7 },
                                      xxl: { span: 17, offset: 7 },
                                    }}
                                  >
                                    <Button
                                      type="dashed"
                                      disabled={fields.length > 2 ? true : false}
                                      onClick={() => add()}
                                      style={{ width: "100%" }}
                                    >
                                      <PlusOutlined /> Add Project
                                    </Button>
                                  </Form.Item>


                                </>
                              )}
                            </Form.List>
                          </>
                        )
                      }}
                    </Form.Item>

                    <Form.Item
                      name="is_hotel_name"
                      label="IS Hotel Name"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter IS Hotel Name",
                        },
                      ]}
                    >

                      <Input placeholder="Enter IS Hotel Name" />

                    </Form.Item>
                    <Form.Item name="myp_hotel_name" label="MYP Hotel Name">

                      <Input
                        placeholder="Enter MYP Hotel Name"
                      />

                    </Form.Item>

                    <Form.Item
                      name="file_location"
                      label="File Location"
                      initialValue="S3"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Your File Location",
                        },
                      ]}
                    >
                      <Select
                        disabled
                        // defaultValue="S3"
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter File Location"
                      >
                        <Option value="IS">IS</Option>
                        <Option value="S3">S3</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item
                      name="time_zone"
                      label="Time Zone"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Time Zone",
                        },
                      ]}
                    >

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter Time Zone"
                      >
                        <Option value="AKST">AKST</Option>
                        <Option value="PST">PST</Option>
                        <Option value="CST">CST</Option>
                        <Option value="EST">EST</Option>
                        <Option value="MT">MT</Option>
                        <Option value="MDT">MDT</Option>
                        <Option value="AST">AST</Option>
                        <Option value="HST">HST</Option>
                        <Option value="NST">NST</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.pms_id !== currentValues.pms_id

                      }
                    >
                      {({ getFieldValue }) => {
                        const pmsId = getFieldValue("pms_id");
                        const pmsNewFelds = [];
                        if (pmsId) {
                          pmsId.forEach((pmsID) => {
                            const result = pmsGetData.find((e) => e._id === pmsID);
                            if (result) {
                              pmsNewFelds.push(
                                <Form.Item
                                  label={result.pms_name + " PMS Version"}
                                  key={pmsID}
                                  style={{ marginBottom: "5px" }}
                                  name={["pms", pmsID]}
                                  initialValue={result.pms_version !== undefined ? result.pms_version : null}
                                >
                                  <InputNumber placeholder="PMS version" style={{ width: "60%" }} min={0} />
                                </Form.Item>
                              );
                            }
                          });
                        }
                        return (
                          <>
                            <Form.Item
                              name="pms_id"
                              label="PMS"
                              style={{ marginBottom: "5px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter PMS",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                mode="multiple"
                                optionFilterProp="children"
                                placeholder="Enter PMS"
                              // onChange={pmsOnChange}
                              >
                                {pmsOptions}
                              </Select>

                            </Form.Item>


                            {pmsNewFelds.length ? (
                              <div style={{ marginBottom: "24px" }}>{pmsNewFelds}</div>
                            ) : (
                              <div style={{ marginBottom: "24px" }}></div>
                            )}
                          </>
                        )








                      }}
                    </Form.Item>
                    <Form.Item
                      name="rooms"
                      label="Rooms"
                      rules={[
                        {
                          type: "number",
                          message: "Please Enter Numbers",
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Enter Rooms"
                        precision={0}
                        min={0}
                      />

                    </Form.Item>

                    <Form.Item name="qc_hotel_id" label="QC Hotel ID">

                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Enter QC Hotel ID"
                        min={0}
                      />

                    </Form.Item>


                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <Form.Item name="myp_id" label="MYP Hotel ID">

                      <InputNumber
                        disabled={true}
                        style={{ width: "100%" }}
                        placeholder="Enter MYP Hotel ID"
                        min={0}
                      />

                    </Form.Item>

                    <Form.Item name="hours_of_operation" label="Hours Of Operation">

                      <AutoComplete
                        options={[{ value: "24/7" }, { value: "Seasonal" }]}
                        filterOption={(inputValue, option) =>
                          option.value
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        }
                        placeholder="Enter Hours Of Operation"
                      />

                    </Form.Item>

                    <Form.Item
                      name="hotel_status"
                      label="Hotel Status"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Hotel Status",
                        },
                      ]}
                    >

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter Hotel Status"
                        onChange={hotelStatusOnChange}
                      >
                        <Option value="Report Set-Up Pending">
                          Report Set-Up Pending
                        </Option>
                        <Option value="Report Set-Up">Report Set-Up</Option>
                        <Option value="WIP Report Set-Up">
                          WIP Report Set-Up
                        </Option>
                        <Option value="Client Success">Client Success</Option>
                        <Option value="Technical">Technical</Option>
                        <Option value="UAT">UAT</Option>
                        <Option value="Audit I">Audit I</Option>
                        <Option value="Audit II">Audit II</Option>
                        <Option value="Go Live Pending">Go Live Pending</Option>
                        <Option value="Live">Live</Option>
                        <Option value="Delayed">Delayed</Option>
                        <Option value="Pending Business">Pending Business</Option>
                        <Option value="Future Business">Future Business</Option>
                        <Option value="Lost">Lost</Option>
                        <Option value="Sold">Sold</Option>
                        <Option value="Soft Live">Soft Live</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item name="signature_type" label="Signature Style">

                      <Select
                        placeholder="Enter Solution"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        notFoundContent={null}
                      >
                        <Option value="NONE">NONE</Option>
                        <Option value="MARRIOTT_STYLE">MARRIOTT_STYLE</Option>
                        <Option value="HIGHGATE_STYLE">HIGHGATE_STYLE</Option>
                        <Option value="CRESCENT_STYLE">CRESCENT_STYLE</Option>
                        <Option value="CRESCENT_ONLY_STYLE">
                          {" "}
                          CRESCENT_ONLY_STYLE
                        </Option>
                        {/* <Option value="FREE_FORM_SIGNING_STYLE">FREE_FORM_SIGNING_STYLE</Option> */}
                        <Option value="MARRIOTT_STYLE_WITH_TEMPLATE">
                          MARRIOTT_STYLE_WITH_TEMPLATE
                        </Option>
                        <Option value="SIGNATURE_END_ENVELOPE_STYLE">
                          SIGNATURE_END_ENVELOPE_STYLE
                        </Option>
                      </Select>

                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.hotel_status !== currentValues.hotel_status ||
                        prevValues.signature_go_live_date !== currentValues.signature_go_live_date
                      }
                    >
                      {({ getFieldValue, setFieldsValue }) => (
                        <div
                          style={
                            ["Live", "Soft Live", "UAT"].includes(
                              getFieldValue("hotel_status"),
                            )
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <Form.Item
                            name="go_live_date"
                            label="Go Live Date"
                            rules={[
                              {
                                required: ["Live", "Soft Live", "UAT"].includes(
                                  getFieldValue("hotel_status"),
                                ),
                                message: "Please Enter Go Live Date",
                              },
                            ]}
                          >

                            <DatePicker
                              style={{ width: "100%" }}
                              placeholder="Enter Go Live Date"
                              // disabledDate={(current) => {
                              //   const signatureGoLiveDate = getFieldValue("signature_go_live_date");
                              //   if (signatureGoLiveDate) {
                              //     return current && moment(current).isAfter(signatureGoLiveDate, 'day');
                              //   } else {
                              //     return false;
                              //   }
                              // }}
                              onChange={(value) => {
                                if (createStatus) {
                                  setFieldsValue({ signature_go_live_date: value })
                                }
                              }}

                            />

                          </Form.Item>
                        </div>
                      )}
                    </Form.Item>
                    <Form.Item name="finance_checklist" label="Daily Finance Checklist" initialValue="parent">

                      <Select
                        placeholder="Select Option"
                        // allowClear
                        showSearch
                        optionFilterProp="children"
                        notFoundContent={null}
                      >
                        <Option value="parent">Parent</Option>
                        <Option value="yes">Yes</Option>
                        <Option value="no">No</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item name="split_by_sub_header" label="Split By Sub Header" initialValue="2">

                      <Select
                        placeholder="Select Option"
                        // allowClear
                        showSearch
                        optionFilterProp="children"
                        notFoundContent={null}
                      >
                        <Option value="2">Parent</Option>
                        <Option value="1">Yes</Option>
                        <Option value="0">No</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item name="adhoc_reports_schedule" label="AdHoc Reports Schedule">

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter AdHoc Reports Schedule"
                      >
                        <Option value="Monday">Monday</Option>
                        <Option value="Tuesday">Tuesday</Option>
                        <Option value="Wednesday">Wednesday</Option>
                        <Option value="Thursday">Thursday</Option>
                        <Option value="Friday">Friday</Option>
                        <Option value="Saturday">Saturday</Option>
                        <Option value="Sunday">Sunday</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item name="pos" label="POS?">

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter POS"
                      >
                        <Option value="1">Yes</Option>
                        <Option value="0">No</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.pos !==
                        currentValues.pos
                      }
                    >
                      {({ getFieldValue }) => (
                        <div
                          style={
                            getFieldValue("pos") === "1"
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <Form.Item
                            name="pos_name"
                            label="POS Name"
                            rules={[
                              {
                                required: getFieldValue("pos") === "1",
                                message: "Please Enter Pos Name",
                              },
                            ]}
                          >

                            <Select
                              notFoundContent={null}
                              mode="tags"
                              showSearch
                              optionFilterProp="children"
                              placeholder="Enter Pos Name"
                            ></Select>

                          </Form.Item>
                        </div>
                      )}
                    </Form.Item>
                    <Form.Item
                      name="mdo_hotel_email"
                      label="MDO Hotel Email"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter MDO Hotel Email",
                        },
                        {
                          type: "email",
                          message: "Please Enter Valid Email",
                        },
                      ]}
                    >
                      <Input placeholder="Enter MDO Hotel Email" />
                    </Form.Item>

                    <Form.Item
                      name="ss3u_hotel_mapping_name"
                      label="SS3U Hotel Mapping Name"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter SS3U Hotel Mapping Name",
                        },
                      ]}
                    >
                      <Input placeholder="Enter SS3U Hotel Mapping Name" />
                    </Form.Item>


                    <Form.Item wrapperCol={{ span: 17, offset: 7 }}>
                      <Button
                        type="primary"
                        onClick={mypHotelToggle}
                      >
                        Next
                      </Button>
                    </Form.Item>


                  </Col>
                </Row>
              </div>

              <div
                style={
                  current === 1 ? { display: "block" } : { display: "none" }
                }
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item
                      name="sign_type"
                      label="Sign Type"
                      initialValue="1"
                      rules={[
                        {
                          required: true,
                          message: "Please select your  file location",
                        },
                      ]}
                    >

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Please Enter Sign Type"
                      // onChange={signTypeOnChange}
                      >
                        <Option value="3">PandaDoc</Option>
                        <Option value="2">Docusign</Option>
                        <Option value="1">None</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.sign_type !== currentValues.sign_type
                      }
                    >
                      {({ getFieldValue }) => (
                        <div
                          style={
                            getFieldValue("sign_type") === "2" ||
                              getFieldValue("sign_type") === "3"
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <Form.Item name="qc_type" label="QC Type" initialValue="1">

                            <Select
                              showSearch
                              optionFilterProp="children"

                            >
                              <Option value="1">CutOff Time</Option>
                              <Option value="2">Mandatory Reports</Option>
                            </Select>

                          </Form.Item>

                        </div>
                      )}
                    </Form.Item>

                    <Form.Item
                      name="enable_triggers"
                      label="Enable Triggers"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.sign_type !== currentValues.sign_type ||
                        prevValues.qc_type !== currentValues.qc_type ||
                        prevValues.go_live_date !== currentValues.go_live_date
                      }
                    >
                      {({ getFieldValue }) => (
                        <div
                          style={
                            getFieldValue("sign_type") === "2" ||
                              getFieldValue("sign_type") === "3"
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <Form.Item
                            name="signature_go_live_date"
                            label="Signature Go live Date"
                            initialValue={moment().local()}
                            rules={[
                              {
                                required:
                                  getFieldValue("sign_type") === "2" ||
                                  getFieldValue("sign_type") === "3",
                                message: "Please Enter Signature Go live Date",
                              },
                              {
                                validator: (_, value) => {
                                  const goLiveDate = getFieldValue("go_live_date");
                                  if (value && goLiveDate) {
                                    if (moment(value).isBefore(goLiveDate, 'day')) {
                                      return Promise.reject("Signature Go live Date Should Be After The Go Live Date");
                                    }
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              placeholder=" Enter Signature Go live Date"
                              disabledDate={(current) => {
                                const goLiveDate = getFieldValue("go_live_date");
                                if (goLiveDate) {
                                  return current && moment(current).isBefore(goLiveDate, 'day');
                                } else {
                                  return false;
                                }
                              }}
                            />

                          </Form.Item>

                          <div
                            style={
                              getFieldValue("qc_type") === "1"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <Form.Item name="qc_cutoff" label="QC Cutoff">

                              <TimePicker
                                // locale={locale}

                                format="HH:mm"
                                style={{ width: "100%" }}
                                placeholder="Enter QC Cutoff Time"
                              />

                            </Form.Item>
                          </div>

                          <div
                            style={
                              getFieldValue("qc_type") === "2"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <Form.Item name="qc_schedule" label="QC Schedule">

                              <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="Enter QC Schedule"
                              >
                                <Option value="15">15 Minutes</Option>
                                <Option value="30">30 Minutes</Option>
                                <Option value="60">1 Hour</Option>
                                <Option value="120">2 Hours</Option>
                                <Option value="240">4 Hours</Option>
                                <Option value="480">8 Hours</Option>
                              </Select>

                            </Form.Item>
                          </div>
                        </div>
                      )}
                    </Form.Item>



                  </Col>
                </Row>
                <div style={{ textAlign: "center" }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>
                  <Button type="primary" onClick={next}>
                    Next
                  </Button>
                </div>
              </div>
              <div
                style={
                  current === 2 ? { display: "block" } : { display: "none" }
                }
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item
                      name="hotel_phone_number"
                      label="Hotel Phone Number"
                      initialValue=""
                      rules={[
                        {
                          pattern: new RegExp(/(\d{3})-(\d{3})-(\d{4})/),
                          message: "Please Enter a Valid Mobile Number"
                        }
                      ]}
                    >
                      <MobileInputMask
                        mask="999-999-9999"
                      />
                    </Form.Item>

                    <Form.Item name="hotel_address" label="Hotel Address">
                      <Input />
                    </Form.Item>

                    <Form.Item name="hotel_city" label="Hotel City">
                      <Input />
                    </Form.Item>

                    <Form.Item name="hotel_state" label="Hotel State">
                      <Input />
                    </Form.Item>

                    <Form.Item name="hotel_country" label="Hotel Country">
                      <Input />
                    </Form.Item>

                    <Form.Item name="unit_num" label="Unit Num">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item name="primary_contact" label="Primary Contact">

                      <Select showSearch optionFilterProp="children">
                        <Option value="General Manager">General Manager</Option>
                        <Option value="Alternate Contact">
                          Alternate Contact
                        </Option>
                        <Option value="Night Auditors">Night Auditors</Option>
                      </Select>

                    </Form.Item>

                    <Form.Item name="general_manager" label="General Manager">
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="gm_email"
                      label="GM Email"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter GM Email",
                        },
                        {
                          type: "email",
                          message: "Please Enter Valid Email",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="gm_phone"
                      label="GM Phone"
                      initialValue=""
                      rules={[
                        {
                          pattern: new RegExp(/(\d{3})-(\d{3})-(\d{4})/),
                          message: "Please Enter a Valid Mobile Number"
                        }
                      ]}
                    >
                      <MobileInputMask
                        mask="999-999-9999"
                      />
                    </Form.Item>

                    <Form.Item name="gm_contact_hours_from" label="GM Contact Hours From">

                      <TimePicker
                        format="HH:mm"
                        style={{ width: "100%" }}
                        placeholder=""
                      />

                    </Form.Item>

                    <Form.Item name="gm_contact_hours_to" label="GM Contact Hours To">

                      <TimePicker
                        format="HH:mm"
                        style={{ width: "100%" }}
                        placeholder=""
                      />

                    </Form.Item>
                  </Col>
                </Row>

                <div style={{ textAlign: "center" }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>
                  <Button type="primary" onClick={next}>
                    Next
                  </Button>

                </div>
              </div>



              <div
                style={
                  current === 3 ? { display: "block" } : { display: "none" }
                }
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }} >
                    <Form.Item
                      {...customProps}
                      name="qc_db_create_and_update"
                      label="QC DB Create Or Update"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter QC DB Create Or Update",
                        },
                      ]}
                      initialValue="0"
                    >

                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Enter QC DB Create Or Update"
                      >
                        <Option value="1">Yes</Option>
                        <Option value="0">No</Option>
                      </Select>

                    </Form.Item>

                  </Col>
                </Row>

                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 8 }} >

                    <Form.Item
                      {...customProps}
                      name="historical_data"
                      label="Historical Hotel (-H Enable)"
                      valuePropName="checked"
                      initialValue={false}
                    >

                      <Switch />
                    </Form.Item>
                    <Form.Item
                      {...customProps}
                      name="live_in_s3"
                      label="Live Hotel (-L Enable)"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      {...customProps}
                      name="qc_enable_periodic_update"
                      label="Compliance Update"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.qc_enable_periodic_update !== currentValues.qc_enable_periodic_update
                      }
                    >
                      {({ getFieldValue }) => (
                        <Form.Item
                          {...customProps}
                          name="qc_enable_periodic_update_rapid"
                          label="Compliance Rapid Update"
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Switch
                            disabled={
                              getFieldValue("qc_enable_periodic_update")
                                ? false
                                : true
                            }
                          />
                        </Form.Item>
                      )}
                    </Form.Item>

                    <Form.Item
                      {...customProps}
                      name="ai_enabled"
                      label="AI Enabled"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      {...customProps}
                      name="serverless_hotel"
                      label="Serverless Migration"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch
                        disabled={
                          process.env.REACT_APP_PLATFORM_TYPE &&
                          process.env.REACT_APP_PLATFORM_TYPE === "GENERIC"
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.ai_enabled !== currentValues.ai_enabled ||
                        prevValues.primary_hmg_id !== currentValues.primary_hmg_id
                      }
                    >
                      {({ getFieldValue }) => {
                        const primaryHmgId = getFieldValue("primary_hmg_id");

                        const hotelsOptions = hotelGetData
                          .filter((item) => {
                            if (primaryHmgId) {
                              if (item.primary_hmg_id === primaryHmgId) {
                                return true;
                              } else {
                                return false;
                              }
                            } else {
                              return false;
                            }
                          })
                          .sort((a, b) => a.hotel_code.localeCompare(b.hotel_code))
                          .map((d) => (
                            <Option key={d._id} value={d.hotel_code}>
                              {d.hotel_code} - {d.hotel_name}
                            </Option>
                          ));

                        return (<div
                          style={
                            getFieldValue("ai_enabled")
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <Form.Item
                            {...customProps}
                            name="copy_from_hotel_code"
                            label="Copy From Hotel Code"
                            rules={[
                              {
                                required: getFieldValue("ai_enabled"),
                                message: "Please Enter Copy From Hotel Code",
                              },
                            ]}
                          >

                            <Select
                              showSearch
                              optionFilterProp="children"
                              placeholder="Enter Copy From Hotel Code"
                              disabled={
                                initialValue && initialValue.sp_update_status
                                  ? true
                                  : false
                              }
                            >
                              {hotelsOptions}
                            </Select>

                          </Form.Item>
                        </div>)
                      }}

                    </Form.Item>

                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 10 }} >
                    <Form.Item
                      {...customProps}
                      name="man_append_to_same_trigger"
                      label="Append Missed Reports to Same Envelop"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      {...customProps}
                      name="check_for_prv_envelop"
                      label="Check for Previous Envelops "
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch disabled={true} />
                    </Form.Item>

                    <Form.Item
                      {...customProps}
                      name="pna_hotel"
                      label="PNA Hotel"
                      valuePropName="checked"
                      initialValue={true}
                    >
                      <Switch onChange={this.pnaHotelOnChange} />
                    </Form.Item>

                    <Form.Item
                      {...customProps}
                      name="myp_hotel"
                      label="MYP Hotel"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.myp_hotel !== currentValues.myp_hotel ||
                        prevValues.myp_id !== currentValues.myp_id
                      }
                    >
                      {({ getFieldValue }) => (
                        <div
                          style={
                            process.env.REACT_APP_PLATFORM_TYPE &&
                              process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT"
                              ? { display: "none" }
                              : { display: "block" }
                          }
                        >
                          <div
                            style={
                              getFieldValue("myp_hotel") &&
                                typeof getFieldValue("myp_id") === "number"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <Form.Item
                              {...customProps}
                              name="no_of_files_expected"
                              label="No Of Files Expected"
                              rules={[
                                {
                                  required:
                                    getFieldValue("myp_hotel") &&
                                    typeof getFieldValue("myp_id") === "number" &&
                                    process.env.REACT_APP_PLATFORM_TYPE &&
                                    process.env.REACT_APP_PLATFORM_TYPE === "GENERIC",
                                  message: "Please Enter No Of Files Expected",
                                },
                              ]}
                            >
                              <InputNumber
                                style={{ width: "100%" }}
                                placeholder="Enter No Of Files Expected"
                                precision={0}
                                min={0}
                              />
                            </Form.Item>
                          </div>
                          <div
                            style={
                              getFieldValue("myp_hotel") &&
                                typeof getFieldValue("myp_id") === "number"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <Form.Item {...customProps} name="myp_str_id" label="STR Id">

                              <Input
                                style={{ width: "100%" }}
                                placeholder="Enter STR Id"
                              />

                            </Form.Item>
                          </div>
                          <div
                            style={
                              getFieldValue("myp_hotel")
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <Form.Item
                              {...customProps}
                              name="myp_pms"
                              label="MYP PMS"
                              rules={[
                                {
                                  required:
                                    getFieldValue("myp_hotel") &&
                                    process.env.REACT_APP_PLATFORM_TYPE &&
                                    process.env.REACT_APP_PLATFORM_TYPE === "GENERIC",
                                  message: "Please Enter MYP PMS",
                                },
                              ]}
                            >

                              <Select
                                // style={{ width: "calc(100% - 30px)" }}
                                showSearch
                                optionFilterProp="children"
                                placeholder="Enter MYP PMS"
                              >
                                {mypoptionlist}
                              </Select>

                            </Form.Item>
                          </div>
                        </div>
                      )}
                    </Form.Item>
                    <Form.Item
                      {...customProps}
                      name="is_enabled"
                      label="QC Enabled"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col  xs={{ span: 24 }} md={{ span: 6 }}>
                  <Form.Item
                      {...customProps}
                      name="intellisight_plus"
                      label="IntelliSight Plus"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
                <div style={{ textAlign: "center" }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>

                  <Button type="primary" htmlType="submit">
                    {createStatus ? "Create" : "Update"}
                  </Button>
                </div>
              </div>
            </Form>
          </Panel>
        </Collapse>
      </div >
    );
  }
}

export default FormOne;
